import React, {useEffect} from 'react';
import EzFormControl from 'wobi-web-common/dist/components/EzFormControl';
import * as yup from 'yup';
import moment from 'moment';
import {agentDeveloperUtils, Breakpoints} from 'wobi-web-common';

import { Grid, Checkbox, TextField, useMediaQuery } from '@mui/material';

import { makeStyles } from 'tss-react/mui';

import {FormattedMessage, useIntl} from 'react-intl';
import {Blue} from 'wobi-web-common/dist/config/colors.config';
import {
  validateDate,
  validateForHebrew,
  validatePhoneNumber,
  validateForIsraeliID,
} from '../../../utils/validationHelpers';
import {fireGtmEvent} from '../../../utils/marketing.utils';
import AlwaysOnTooltip from '../../../components/AlwaysOnTooltip';
import {getOffersFields, getDetailForm} from '../../../utils/persistOfferDetails';
import TravelerFormBlock from '../../../components/TravelerFormBlock.jsx';

import PropTypes from 'prop-types';

const Tab2 = React.memo(
  ({
    idForAccessibility,
    className,
    submitCallback,
    validationCallback,
    formikSetField,
    formikHandleChange,
    formikErrors,
    formikValues,
    formikSetTouched,
    formikValidateForm,
    actionButton,
    onButtonClickOTP,
  }) => {
    const intl = useIntl();
    const { classes } = useStyles();
    const policyHolderMinDOB = moment().subtract(95, 'year');
    const policyHolderMaxDOB = moment().subtract(0, 'year');
    const isDesktop = !useMediaQuery(`(max-width:${Breakpoints.mobile}px)`);

    useEffect(() => {
      const otpToken = getOffersFields('otpToken');
      if (formikValues.phoneFromSf && otpToken) {
        formikSetField('phone1', formikValues.phoneFromSf);
        fireGtmEvent('Detailrecovery', {
          travelers: formikValues.travelers,
        });
      }
    }, [formikValues.phoneFromSf]);

    const validationObject = {
      isLeftIsrael: yup.boolean().oneOf([true], 'שדה חובה'),
      phone1: validatePhoneNumber(),
    };
    const firstNameValidationText = 'נא להזין שם פרטי בעברית';
    const lastNameValidationText = 'נא להזין שם משפחה בעברית';

    useEffect(() => {
      setTimeout(() => {
        try {
          const offersFields = getDetailForm().values;
          const travelers = offersFields.travelers;
          if (!travelers || !travelers.length && !formikValues.travelers?.length) {
            const travelersArray = [];
            for (let i = 0; i < 10; i++) {
              if (offersFields[`ID${i + 1}`]) {
                travelersArray.push({
                  ID: offersFields[`ID${i + 1}`],
                  dob: offersFields[`dob${i + 1}`],
                  firstName: offersFields[`firstName${i + 1}`],
                  lastName: offersFields[`lastName${i + 1}`],
                  gender: offersFields[`gender${i + 1}`],
                });
              }
            }
            formikSetField('travelers', travelersArray);
          } else if (travelers && travelers.length && !formikValues.travelers?.length) {
            formikSetField('travelers', travelers);
          }
        } catch {
          formikSetField('travelers', [
            {
              ID: '',
              dob: '',
              firstName: '',
              lastName: '',
            },
          ]);
        }
      }, 100);
    }, []);

    const selectValue = formikValues.policyholdNum;

    // Dynamic block for validation IDx and OtherX fields on unique
    if (Number(selectValue) === 1) {
      formikValues.travelers.forEach((traveler, index) => {
        delete validationObject['ID' + (index + 1)];
      });

      validationObject.ID1 = validateForIsraeliID();
      validationObject.dob1 = validateDate(
        policyHolderMinDOB,
        policyHolderMaxDOB,
      );
      validationObject.firstName1 = validateForHebrew(
        firstNameValidationText,
      );
      validationObject.lastName1 = validateForHebrew(lastNameValidationText);
      validationObject.gender1 = yup
        .string()
        .typeError()
        .required('שדה חובה');
      validationObject.phone1 = validatePhoneNumber();

      // dynamic callback to React.Component method
      setTimeout(() => {
        validationCallback(validationObject);
      }, 1);
    } else {
      formikValues.travelers.forEach((traveler, index) => {
        if (selectValue >= index + 1) {
          const temporaryArray = [];
          formikValues.travelers.forEach((traveler2, index2) => {
            if (index !== index2 && selectValue >= index2 + 1) {
              temporaryArray.push(yup.ref('ID' + (index2 + 1)));
            }
          });
          validationObject.phone1 = validatePhoneNumber();
          validationObject['ID' + (index + 1)] = validateForIsraeliID().notOneOf(
            temporaryArray,
            'שדה זה חייב להיות ייחודי',
          );
          validationObject['dob' + (index + 1)] = validateDate(
            policyHolderMinDOB,
            policyHolderMaxDOB,
          );
          validationObject['firstName' + (index + 1)] = validateForHebrew(
            firstNameValidationText,
          );
          validationObject['lastName' + (index + 1)] = validateForHebrew(
            lastNameValidationText,
          );
          validationObject[
            'gender' + (index + 1)
          ] = yup.string().typeError().required('שדה חובה');
        }
      });
      setTimeout(() => {
        validationCallback(validationObject);
      }, 1); // dynamic callback to React.Component method
    }

    const validateOtpFirstPhoneFromSfIsSame = async () => {
      const detailsForm = sessionStorage.getItem('travel.details-form');
      const detailsFormParsed = JSON.parse(detailsForm);
      const phoneFromWeb = detailsFormParsed?.values?.phone1; // phone entered on web
      const phoneFromSf = detailsFormParsed?.values?.phoneFromSf; // phone saved on lead
      if (phoneFromWeb !== phoneFromSf) {
        formikSetField('phone1', phoneFromSf);
        sessionStorage.removeItem('travel.details-form');
        sessionStorage.removeItem('otpFirst');

        window.location.reload();
      }
    };

    const handleSubmit = async () => {
      // validation
      formikValues.travelers.forEach((traveler, index) => {
        const temporaryArray = [];
        validationObject['ID' + (index + 1)] = validateForIsraeliID().notOneOf(
          temporaryArray,
          'שדה זה חייב להיות ייחודי',
        );
        validationObject['dob' + (index + 1)] = validateDate(
          policyHolderMinDOB,
          policyHolderMaxDOB,
        );
        validationObject['firstName' + (index + 1)] = validateForHebrew(
          firstNameValidationText,
        );
        validationObject['lastName' + (index + 1)] = validateForHebrew(
          lastNameValidationText,
        );
        validationObject[
          'gender' + (index + 1)
        ] = yup.string().typeError().required('שדה חובה');
      });
      setTimeout(() => {
        validationCallback(validationObject);
      }, 1);
      const errors = await formikValidateForm();
      if (Object.keys(errors).length === 0) {
        fireGtmEvent('confirmPolicyOwners', {
          insuredNumber: formikValues.phone1,
          birthDate: formikValues.dob1,
          gender: formikValues.gender1,
        });
        const {values} = JSON.parse(sessionStorage.getItem('travel.details-form')) || {};
        const {phone1} = values || {};

        if (phone1 && phone1.length < 10) {
          formikSetField('phone1', phone1);
          formikSetTouched('phone1', true);
          window.rollbar.error(JSON.stringify({
            browser: window.navigator.appCodeName,
            browserVersion: window.navigator.appVersion,
            field: 'phone1',
            fieldValue: formikValues.phone1,
          }));
        } else {
          // if otpfirst add validation SFphone = phone 1 ? nothing : remove medical info
          if (sessionStorage.getItem('otpFirst')) {
            validateOtpFirstPhoneFromSfIsSame();
          }
          submitCallback(2);
        }
      } else {
        Object.keys(validationObject).forEach((field) => formikSetTouched(field, true));
      }
    };

    const FormBlocks = formikValues.travelers.map((traveler, key) => (
      <TravelerFormBlock
        key={key + formikValues.travelers.length}
        traveler={traveler}
        formikSetField={formikSetField}
        formikValues={formikValues}
        index={(Number(key) + 1)}
        intl={intl}
      />
    ));

    return (
      <div className={className ? className : classes.insuredForm} id={idForAccessibility} role='tabpanel'>
        <div className={classes.general}>
          <div>
            <EzFormControl
              name='phone1'
              labelFor='phone1'
              label='טלפון מבוטח ראשי'
              isInlineLabel={false}
            >
              <TextField
                id='phone1'
                data-testid='main-phone-number'
                onChange={formikHandleChange}
                value={formikValues.phone1}
                margin='normal'
                variant='outlined'
              />
            </EzFormControl>
          </div>
          <div>
            <AlwaysOnTooltip
              containerStyle={classes.containerStyle}
              show={isDesktop && !formikValues.phoneFromSf}
              kind='Alert'
              aria-label={intl.formatMessage({id: 'step1.tab2.phone'})}
              data-testid='phone1-error'
            >
              <div className={classes.bannerWrapperTolTipOTP}>
                <div className={classes.textContentTolTipOTP}>
                  <div className={classes.titleTolTipOTP}>{intl.formatMessage({id: 'stickyTopBanner.title'})}</div>
                  <div className={classes.subtitleTolTipOTP}>{intl.formatMessage({id: 'stickyTopBanner.subtitle'})}</div>
                  <span className={classes.buttonTolTipOTP} onClick={onButtonClickOTP}>
                    {intl.formatMessage({id: 'stickyTopBanner.buttonText'})}
                  </span>
                </div>
              </div>
            </AlwaysOnTooltip>
          </div>
        </div>
        <Grid container spacing={0} className={classes.main}>
          {FormBlocks}
        </Grid>
        <Grid container spacing={1} className={classes.summary}>
          <Grid size={12}>
            <EzFormControl name='isLeftIsrael' label='' isInputLabel>
              <Checkbox
                id='isLeftIsrael'
                label={intl.formatMessage({id: 'step1.tab2.isLeftIsrael'})}
                onChange={(event) => formikSetField('isLeftIsrael', event.target.checked)
                }
                checked={formikValues.isLeftIsrael}
                data-testid='is-left-israel'
              />
              <label htmlFor='isLeftIsrael'>
                {intl.formatMessage({id: 'step1.tab2.isLeftIsrael'})}
              </label>
              <br />
            </EzFormControl>
          </Grid>
          <Grid size={12}>
            {actionButton &&
              actionButton({
                children: <FormattedMessage id='continue' />,
                className: classes.submitBtn,
                size: 'large',
                onClick: handleSubmit,
                variant: 'contained',
                'data-testid': 'continue-button-2',
                'aria-label': formikErrors && Object.keys(formikErrors).length ?
                  `${intl.formatMessage({id: 'continue'})}, ` +
                  `${intl.formatMessage({id: 'validation.needToFillAllFields'})}` :
                  null,
              })}
          </Grid>
        </Grid>
      </div>
    );
  },
);

const useStyles = makeStyles()((theme) => ({
  text: {
    color: theme.palette.text.secondary,
    fontSize: theme.typography.pxToRem(10.5),
    paddingLeft: 30,
    paddingRight: 10,
    marginBottom: 10,
  },
  containerStyle: {
    marginBottom: '15px',
    marginLeft: '1rem',
  },
  bannerWrapperTolTipOTP: {

  },
  textContentTolTipOTP: {
    textAlign: 'left',
  },
  titleTolTipOTP: {
    fontWeight: 700,
    fontSize: '16px',
  },
  subtitleTolTipOTP: {
    fontSize: '14px',
    color: '#333',
  },
  buttonTolTipOTP: {
    color: agentDeveloperUtils.getPrimaryColor(450),
    padding: '1px 0',
    fontWeight: 'bold',
    cursor: 'pointer',
    marginTop: '4px',
    textDecoration: 'underline',
    zIndex: 111,
    pointerEvents: 'auto',
  },
  datepickerError: {
    marginTop: 0,
    marginBottom: 5,
  },
  general: {
    display: 'flex',
    flexFlow: 'row wrap',
    '&>div:ffirst-of-type': {margin: '0 28px 16px 0'},
    '&>div:last-of-type': {minWidth: 163},
    '& .MuiFormControl-root.MuiFormControl-marginNormal': {marginTop: 0},
    '& label.MuiFormLabel-root': {
      width: 'auto',
      color: theme.palette.primary.main,
      fontWeight: 700,
      fontSize: theme.typography.pxToRem(17.5),
      transform: 'none',
      margin: '0 0 10px 12px',
    },
    [theme.breakpoints.down(650)]: {flexFlow: 'column nowrap'},
    [theme.breakpoints.up(768)]: {flexFlow: 'column nowrap'},
    [theme.breakpoints.up(1109)]: {flexFlow: 'row nowrap'},
  },
  select: {
    width: 170,
    [theme.breakpoints.down(Breakpoints.mobile)]: {
      width: '235px',
      display: 'block',
    },
  },
  title: {
    color: theme.palette.primary.main,
    fontWeight: 'bold',
    padding: '20px 12px 12px',
    alignSelf: 'flex-start',
  },
  insuredForm: {
    flexFlow: 'column nowrap',
    justifyContent: 'flex-start',
    '& .MuiOutlinedInput-input': {padding: '12px 25px'},
    '& .MuiFormControl-root.MuiFormControl-marginNormal': {marginBottom: 0},
    '& .MuiFormHelperText-contained': {margin: '3px 12px 0'},
    '& .MuiFormHelperText-root.Mui-error': {marginBottom: 0},
    '& .MuiOutlinedInput-root': {maxWidth: 237},
    '& .MuiFormLabel-root': {transform: 'translate(25px, 13px)'},
  },
  birthdayInput: {
    '& .MuiOutlinedInput-input': {paddingRight: 0},
  },
  main: {
    minWidth: 260,
  },
  insured: {
    flexFlow: 'column nowrap',
    justifyContent: 'flex-start',
    alignItems: 'center',
    padding: '0 22px 24px',
    position: 'relative',
    '&::before': {
      content: '\' \'',
      display: 'block',
      width: 2,
      height: '90%',
      position: 'absolute',
      top: '50%',
      transform: 'translateY(-50%)',
      borderLeft: `2px dotted ${Blue[100]}`,
      right: -1,
      pointerEvents: 'none',
    },
    '&::after': {
      content: '\' \'',
      display: 'block',
      width: '90%',
      height: 2,
      position: 'absolute',
      right: '50%',
      transform: 'translateX(50%)',
      borderBottom: `2px dotted ${Blue[100]}`,
      bottom: -1,
      pointerEvents: 'none',
    },
    '&:last-of-type': {'&::before': {display: 'none'}},
    [theme.breakpoints.down(1528)]: {
      maxWidth: '50%',
      flexBasis: '50%',
    },
    [theme.breakpoints.down(1268)]: {
      maxWidth: '100%',
      flexBasis: '100%',
      '&::before': {display: 'none'},
    },
    [theme.breakpoints.down(Breakpoints.mobile)]: {
      paddingRight: 0,
      alignItems: 'flex-start',
    },
  },
  title2: {
    color: theme.palette.secondary.main,
    margin: '9px 12px 0 25px',
    fontSize: theme.typography.pxToRem(15.75),
  },
  gender: {
    display: 'flex',
    flexFlow: 'row nowrap',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    marginTop: 12,
    width: '100%',
    maxWidth: 237,
    '& .MuiFormGroup-row': {justifyContent: 'flex-end'},
    '& .MuiFormHelperText-root.Mui-error': {position: 'relative',
      right: 56},
  },
  hide: {
    display: 'none',
  },
  summary: {
    position: 'relative',
    '&::after': {
      content: '\' \'',
      display: 'block',
      width: '100%',
      height: 4,
      position: 'absolute',
      backgroundColor: theme.palette.background.paper,
      top: 2,
      pointerEvents: 'none',
    },
    '& .Mui-error': {
      margin: '-8px 34px 0',
      [theme.breakpoints.down(1111)]: {marginTop: 0},
    },
    '& [class^=makeStyles-inlineLabel]': {
      height: 40,
      [theme.breakpoints.down(Breakpoints.mobile)]: {
        marginBottom: 20,
        maxWidth: 245,
      },
    },
  },
  submitBtn: {
    fontSize: theme.typography.fontSize,
    width: 132,
    marginTop: 8,
  },
}));

Tab2.propTypes = {
  idForAccessibility: PropTypes.string,
  className: PropTypes.string,
  submitCallback: PropTypes.func,
  validationCallback: PropTypes.func,
  formikSetField: PropTypes.func,
  formikHandleChange: PropTypes.func,
  formikErrors: PropTypes.object,
  formikValues: PropTypes.shape({
    travelers: PropTypes.array,
    policyholdNum: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    phone1: PropTypes.string,
    isLeftIsrael: PropTypes.bool,
    dob1: PropTypes.string,
    gender1: PropTypes.string,
    phoneFromSf: PropTypes.string,
  }),
  formikSetTouched: PropTypes.func,
  formikValidateForm: PropTypes.func,
  actionButton: PropTypes.func,
  onButtonClickOTP: PropTypes.func,
};

export default Tab2;
